function updateParallax() {
    document.querySelectorAll(".parallax-bg").forEach((el) => {
        const speed = parseFloat(el.dataset.parallaxSpeed || 0.5);
        const offset = window.scrollY * speed;
        el.style.backgroundPosition = `center calc(50% + ${offset}px)`;
        el.classList.add("loaded"); // make sure this line runs
    });
}

document.addEventListener("scroll", updateParallax);
window.addEventListener("load", updateParallax);
